"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandoutModal = exports.SpecialModal = exports.DirectionModal = exports.InformationModal = exports.WarningModal = exports.ErrorModal = exports.SuccessModal = void 0;
const react_1 = __importDefault(require("react"));
const modal_types_1 = require("./modal-types");
const modal_message_1 = require("./modal-message");
const SuccessModal = (props) => {
    return react_1.default.createElement(modal_message_1.MessageModal, Object.assign({ type: modal_types_1.ModalType.success }, props));
};
exports.SuccessModal = SuccessModal;
const ErrorModal = (props) => {
    return react_1.default.createElement(modal_message_1.MessageModal, Object.assign({ type: modal_types_1.ModalType.error }, props));
};
exports.ErrorModal = ErrorModal;
const WarningModal = (props) => {
    return react_1.default.createElement(modal_message_1.MessageModal, Object.assign({ type: modal_types_1.ModalType.warning }, props));
};
exports.WarningModal = WarningModal;
const InformationModal = (props) => {
    return react_1.default.createElement(modal_message_1.MessageModal, Object.assign({ type: modal_types_1.ModalType.information }, props));
};
exports.InformationModal = InformationModal;
const DirectionModal = (props) => {
    return react_1.default.createElement(modal_message_1.MessageModal, Object.assign({ type: modal_types_1.ModalType.direction }, props));
};
exports.DirectionModal = DirectionModal;
const SpecialModal = (props) => {
    return react_1.default.createElement(modal_message_1.MessageModal, Object.assign({ type: modal_types_1.ModalType.special }, props));
};
exports.SpecialModal = SpecialModal;
const StandoutModal = (props) => {
    return react_1.default.createElement(modal_message_1.MessageModal, Object.assign({ type: modal_types_1.ModalType.standout }, props));
};
exports.StandoutModal = StandoutModal;
